import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const CustomSelect = ({ options, name, isMulti=false }) => {
  const [value, setValue] = React.useState();

  const onChange = (val) => {
    if(isMulti) {
      setValue(val.map(({value}) => value))
    } else {
      setValue(val.value)
    }
  }

  return(<>
    <Select
      onChange={onChange}
      options={options}
      isMulti={isMulti}
    />
    {name && <input type="hidden" name={name} value={value}/>}
  </>)
}

CustomSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  name: PropTypes.string,
  isMulti: PropTypes.bool,
}

export default CustomSelect;
